/**
 * Parse query string to object.
 *
 */

interface Query {
  [key: string]: string;
}

export function parseQuery(queryString: string): Query {
  const query: Query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }

  return query;
}
